<template>

  <b-container fluid>

    <b-row>
        <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >

          <b-img src="../assets/480x320-blade.png" center fluid alt="Responsive image" style=" margin-top:5%"/>
                <b-card title=""  sub-title="" style=" margin-top:1%">

          <form role="form" v-on:submit.prevent="login()"  v-if="!busy">
                            <fieldset>
                                <div class="form-group">
                                    <input v-model="data.body.username" class="form-control" placeholder="Username" name="email" type="text" autofocus="">
                                </div>
                                <div class="form-group">
                                    <input v-model="data.body.password" class="form-control" placeholder="Password" name="password" type="password" value="">                                   
                                </div>

                                <!-- Change this to a button or input when using this as a form -->
                                <button type="submit" class="btn btn-lg btn-blade btn-block" v-bind:disabled="!this.data.body.username.trim() || !this.data.body.password.trim()">Login</button>
                                <br/>
                                <button type="button" class="btn btn-lg btn-blade btn-block" v-on:click="showCreateDemoUserForm">Create Account</button>
                                <br/>
                                <b-link :to="'reset'">Forgot Password</b-link>
                            </fieldset>
                        </form>

                          <div class="loader"> <stretch v-if="busy" ></stretch> </div>
            </b-card>
        </b-col>
    </b-row>
    <b-row>
      <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >
          <b-alert :show="hasError" variant="danger" @dismissed="hasError=false">
            <span v-html="errorMsg"></span>
            <!-- <b-button variant="danger" size="sm" v-on:click="forwardToAppStream">
                  Retry
            </b-button> -->
          </b-alert>
      </b-col>
    </b-row>
    <reset-password-notice ref="resetnotice"></reset-password-notice>
    <b-row>
        <b-img src="../assets/stringnosis.png" center fluid alt="stringnosis logo" style=" margin-top:2%"/>
    </b-row>
    <div slot="footer" class="w-100">
      <license-footer></license-footer>
    </div>
</b-container>
</template>

<script>
import { Stretch } from 'vue-loading-spinner'
import ResetPasswordNotice from './ResetPasswordNotice'
import LicenseFooter from './LicenseFooter'
import { INVALID_PARAM_EXCEPTION, INVALID_PARAM_EXCEPTION_MSG, NOT_AUTHOR_EXCEPTION, NOT_AUTHOR_EXCEPTION_MSG, 
         USER_NOT_FOUND_EXCEPTION, PASS_RESET_REQ_EXCEPTION, PASS_RESET_REQ_EXCEPTION_MSG } from '../../src/constants'

const moment = require('moment')

export default {
  name: 'Login',
  components: { Stretch, ResetPasswordNotice, LicenseFooter },
  data () {
    return {
      context: 'login context',
      busy: false,
      hasError: false,
      appSteamError: false,
      loginErrorMsg: 'There was an error logging in. Please check your credentials',
      appStreamErrorMsg: '',
      errorMsg: '',
      token: null,
      data: {
        body: {
          username: '',
          password: ''
        },
        rememberMe: false,
        fetchUser: true
      },
      error: null
    }
  },
  mounted () {
    // console.log(this.$auth.redirect())
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
    const self = this
    self.$eventBus.$on('reset-code-sent', () => {
      self.$router.push('/change')
    })

    self.$eventBus.$on('reset-code-canceled', () => {
      self.$router.push('/')
    })
  },
  methods: {
    showCreateDemoUserForm () {
      var self = this
      self.hasError = false
      self.busy = false
      self.$router.push('/createdemouser')
    },
    login () {
      var self = this
      self.hasError = false
      self.busy = true
      self.$auth.login(self.data.body.username.trim(), self.data.body.password.trim()).then(response => {
        self.busy = false
        self.token = response.data.token

        if (!self.validateLogin()) {
          self.busy = false
          self.errorMsg = 'Subscription expired; please contact administrator or <a href="mailto:support@stringnosis.com"> support@stringnosis.com </a>'
          self.hasError = true
        } else if (self.passwordChangeIsRequired()) {
          self.$eventBus.$emit('show-reset-notice')
        } else if (!self.isValidScheduledSubscription()) {
          self.busy = false
          self.errorMsg = 'Subscription not yet started; please contact administrator or <a href="mailto:support@stringnosis.com"> support@stringnosis.com </a>'
          self.hasError = true
        } else {
          self.$router.push('/instances')
        }
      }).catch(error => {
        self.busy = false
        self.errorMsg = self.loginErrorMsg
        self.hasError = true

        console.log()
        if (error.response && error.response.data === INVALID_PARAM_EXCEPTION) {
          self.errorMsg = INVALID_PARAM_EXCEPTION_MSG
        } else if (error.response && error.response.data === NOT_AUTHOR_EXCEPTION) {
          self.errorMsg = NOT_AUTHOR_EXCEPTION_MSG
        } else if (error.response && error.response.data === USER_NOT_FOUND_EXCEPTION) {
          self.errorMsg = NOT_AUTHOR_EXCEPTION_MSG
        } else if (error.response && error.response.data === PASS_RESET_REQ_EXCEPTION) {
          self.errorMsg = PASS_RESET_REQ_EXCEPTION_MSG
        } else {
          if (error.response.status === 500) {
          // just leave default error message as is for now
          }
        }
      })
    },
    parseSerializedDate (dt) {
      const values = dt.split('-')
      if (values.length < 2) {
        throw new Error('unexpected date value')
      }
      return values[0]
    },
    isValidScheduledSubscription () {
      const self = this
      let payLoad = self.$helpers.unwrap(self.token)

      let sssd = payLoad['blade:sssd']
      sssd = sssd.replace(/"/g, '')

      let today = moment(Date.now())
      let scheduledSubscriptionstartdate = moment(sssd)

      if (moment.utc(scheduledSubscriptionstartdate).isSameOrBefore(today)) {
        return true
      }

      return false
    },
    validateLogin () {
      const self = this
      let payLoad = self.$helpers.unwrap(self.token)
      // let iss = payLoad['blade:iss']
      // let fld = payLoad['blade:fld']
      // let dur = payLoad['blade:dur']
      let durd = payLoad['blade:durd']
      let ssd = payLoad['blade:ssd']

      // iss = iss.replace(/"/g, '')
      // fld = fld.replace(/"/g, '')
      ssd = ssd.replace(/"/g, '')

      // let dtIssued = moment(iss)
      // let firstLogin = moment(fld)
      let today = moment(Date.now())
      let subscriptionstartdate = moment(ssd)

      let minDate = moment.utc('0001-01-01')
      /* if (moment.utc(firstLogin).isSameOrBefore(minDate)) {
        firstLogin = today
      }
      let diff = today.diff(firstLogin, 'days') */

      if (moment.utc(subscriptionstartdate).isSameOrBefore(minDate)) {
        subscriptionstartdate = today
      }
      let diff = today.diff(subscriptionstartdate, 'days')

      // let diff = today.diff(dtIssued, 'days')
      // let licenseValid = diff <= dur * 7
      let licenseValid = diff <= durd

      if (!licenseValid) {
        return false
      }

      return true
    },

    passwordChangeIsRequired () {
      const self = this
      let payLoad = self.$helpers.unwrap(self.token)
      let pwc = payLoad['blade:pwc']

      return pwc === 'True'
    },

    forwardToAppStream () {
      var self = this
      self.busy = true

      self.$appStream.getSignedUrl(self.token).then(response => {
        const url = response.data.streamingURL

        if (!url) {
          self.busy = false
          self.errorMsg = self.appStreamErrorMsg
        } else {
          window.location.href = url
        }
      }).catch(err => {
        if (err) {
          self.busy = false
          self.errorMsg = self.appStreamErrorMsg
        }
      })
    }
  }
}
</script>

<style>
/* #imgbg {
  background: url("../assets/StrinGnosis.jpg") no-repeat center
  height: 100%
} */

.loader {
  width: 100px;
  margin: 0 auto
}
</style>

<style src="../assets/styles.css">

</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue